import { render } from "./ProfessorView.vue?vue&type=template&id=3e597fda&scoped=true"
import script from "./ProfessorView.vue?vue&type=script&lang=js"
export * from "./ProfessorView.vue?vue&type=script&lang=js"

import "./ProfessorView.vue?vue&type=style&index=0&id=3e597fda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e597fda"]])

export default __exports__